module.exports = "/_next/static/images/menuBackground-bbf0f6a90e56ae60e00133ea715752e8.png";